import { find } from "lodash";

import api from "@/api/cloud";
import { set, get } from "@/utils/vuex";

const getInitState = () => ({
	items: [],
});

export default {
	namespaced: true,

	state: getInitState,

	getters: {
		items: get("items"),

		rooms: state => state.items,

		roomByName: state => name => find(state.items, { name }),

		// TODO: Need to verify key used for guid for rooms.
		item: state => id => find(state.items, { id }),

		isInstalled: state => id => {
			const item = find(state.items, { id });
			return item && item.installed;
		},
	},

	mutations: {
		setRooms: set("items"),

		resetState(state) {
			Object.assign(state, getInitState());
		},
	},

	actions: {
		async load({ commit }, community) {
			if (!community) return;

			this._vm.$log(`Rooms: Loading rooms for ${community.name}`);

			try {
				const rooms = await api.getSystems(community.identifier);
				commit("setRooms", rooms);
			} catch (e) {
				commit("setRooms", []);
				throw e;
			}
		},
	},
};
